// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__19jJM","colMaxWidth":"Table_colMaxWidth__1aDs8"};